const theme = {
  colors: {
    primary: '#000000',
    secondary: '#1a1a1a',
    accent: '#444444',
    text: '#ffffff',
    textSecondary: '#999999',
    border: '#333333',
    buttonHover: '#333333',
  },
  spacing: {
    small: '8px',
    medium: '16px',
    large: '24px',
    xlarge: '32px',
    xxlarge: '48px',
  },
  breakpoints: {
    mobile: '576px',
    tablet: '768px',
    laptop: '992px',
    desktop: '1200px',
  }
};

export default theme; 